<template>
    <SwiperCarousel 
        name="tour-hotel-carousel"
        :speed="1000"
        :autoplayDelay="5000"
        :loop="true"
        :freeMode="true"
        :slidesPerViewMobile="1"
        :slidesPerViewTablet="1"
        :slidesPerViewDesktop="1"
        :slidesPerViewLargeDesktop="1"
        :show-navigation="true"
        :show-pagination="true">
        <div 
            class="swiper-slide"
            v-for="(hotel, index) in hotels" 
            :key="index">
            <picture>
                <img :src="hotel.imageUrl" :alt="hotel.imageAltTagText" loading="lazy"/>
            </picture>
        </div>
    </SwiperCarousel>
</template>

<script>
import SwiperCarousel from '../SwiperCarousel.vue'

export default {
    components: {
        SwiperCarousel
    },
    props: {
        hotels: {
            type: Array,
            default: () => [],
        },
    },
}
</script>